export default __webpack_public_path__ + "static/media/whatsapp.63a583c9.png";